import type { Product } from '@model/product'
import { CLOUDINARY_IMAGES } from '../../constants/product'

export interface CloudinaryImagesData {
  PACKSHOT?: string[]
  [key: string]: string[] | undefined
}

export function parseCloudinaryImages(product: Product): CloudinaryImagesData | null {
  if (!product[CLOUDINARY_IMAGES] || product[CLOUDINARY_IMAGES].trim() === '') {
    return null
  }

  try {
    const parsed = JSON.parse(product[CLOUDINARY_IMAGES]) as CloudinaryImagesData
    return parsed
  } catch (error) {
    console.warn('Failed to parse image4 field:', error)
    return null
  }
}

export function getFirstCloudinaryImage(product: Product): string | null {
  const cloudinaryData = parseCloudinaryImages(product)
  if (!cloudinaryData) {
    return null
  }
  const packshotImages = cloudinaryData.PACKSHOT
  if (packshotImages && packshotImages.length > 0) {
    return product.image
  }

  const firstCategory = Object.keys(cloudinaryData).find(
    (key) => Array.isArray(cloudinaryData[key]) && cloudinaryData[key]!.length > 0
  )

  if (firstCategory && cloudinaryData[firstCategory]) {
    return cloudinaryData[firstCategory]![0]
  }

  return null
}

export function getAllCloudinaryImages(product: Product): string[] {
  const cloudinaryData = parseCloudinaryImages(product)
  if (!cloudinaryData || !cloudinaryData.PACKSHOT?.length) {
    return []
  }
  return cloudinaryData.PACKSHOT
}

export function hasCloudinaryImages(product: Product): boolean {
  return getFirstCloudinaryImage(product) !== null
}
